const Loader = () => {
  return (
    <div id="global-loader">
      <div className="page-loader"></div>
    </div>
  );
};
export default Loader;
